import styled from "styled-components";
import {FilterLinkDefaultBox} from "./filter-link.default.box";

export const FilterLinkSIBox = styled(FilterLinkDefaultBox)`
    @media ${({theme}) => theme.mediaQuery.lAndAbove} {
        ::after{
            background: ${props => props.theme.colors.textMiddleDark};
        }
    }
`;
